import { stripHtml } from 'chatspot-core/messages/serializeMessage';
export const updateEditorPluginText = (editorPluginText, setEditorPluginText, messages, combinedExtraIntentProperties) => {
  var _combinedExtraIntentP;
  // Text is only selected when using updatePluginPropsthe content_rewrite intent
  const textValue = (combinedExtraIntentProperties === null || combinedExtraIntentProperties === void 0 || (_combinedExtraIntentP = combinedExtraIntentProperties['content_rewrite']) === null || _combinedExtraIntentP === void 0 ? void 0 : _combinedExtraIntentP.text) || null;
  const responseText = messages.length > 0 && messages[0].displayType === 'SECTIONS' ? messages[0].sections.filter(section => ['HTML', 'COLLABORATE'].includes(section.type) && 'text' in section).map(section => stripHtml(section.text)).join(' ') : '';
  // If the value hasn't changed, or there is no text value, set the context to be from the section
  if (responseText && !textValue || textValue === editorPluginText) {
    // Update the combinedExtraIntentProperties immutably and return the new object
    return Object.assign({}, combinedExtraIntentProperties, {
      ['content_rewrite']: Object.assign({}, combinedExtraIntentProperties === null || combinedExtraIntentProperties === void 0 ? void 0 : combinedExtraIntentProperties['content_rewrite'], {
        text: responseText
      })
    });
  }
  setEditorPluginText(textValue);
  return combinedExtraIntentProperties;
};